import { render, staticRenderFns } from "./JobStatusRelationDetailForm.vue?vue&type=template&id=25f8ed72&"
import script from "./JobStatusRelationDetailForm.vue?vue&type=script&lang=js&"
export * from "./JobStatusRelationDetailForm.vue?vue&type=script&lang=js&"
import style0 from "./JobStatusRelationDetailForm.vue?vue&type=style&index=0&id=25f8ed72&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports